import styled from 'styled-components';

import PageErrorBoundary from '../PageErrorBoundary';

export const StyledErrorBoundary = styled(PageErrorBoundary)`
  font-family: ${({ theme }) => theme.fontFamily.regular};
`;
